
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';

@Component({
  components: {
    DxPopup,
    DxScrollView
  },
})
export default class ProjectIsOnHoldPopup extends Vue {
  showPopup: boolean = false;

  show() {
    this.showPopup = true;
  }

  hide() {
    this.showPopup = false;
  }

  assignId(e: any) {
    e.component.content().setAttribute('id', 'projectIsOnHoldPopup');
  }
}
